export enum BankAccountTypeEnum {
    Cheque = "Cheque",
    SavingsAccount = "SavingsAccount"
}